import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "11.25",
      stroke: "currentColor",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M11.25 12a.75.75 0 0 0 1.5 0h-1.5Zm0-6.782V12h1.5V5.218h-1.5Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.438 11.526a.712.712 0 0 0-1.038.016.79.79 0 0 0 .016 1.083l1.022-1.1Zm4.896 4.957-4.896-4.957-1.022 1.099 4.896 4.957 1.022-1.1Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }